var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotoWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 128,
    viewBox: "0 0 141 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noto:warning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M62.9654 8.42L5.68411 112.42C3.54708 116.44 5.3977 121.27 9.81497 123.21C11.0047 123.73 12.2935 124.01 13.6154 124.02H128.178C133.091 123.98 137.045 120.33 137.001 115.87C136.987 114.674 136.683 113.496 136.109 112.42L78.8279 8.42C78.0865 7.08806 76.9526 5.96891 75.5524 5.18703C74.1522 4.40516 72.5405 3.9912 70.8966 3.9912C69.2527 3.9912 67.641 4.40516 66.2408 5.18703C64.8406 5.96891 63.7067 7.08806 62.9654 8.42Z",
    fill: "#F2A600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M58.9997 15.72L5.24346 113.12C3.2276 116.89 4.96807 121.43 9.12096 123.26C10.2115 123.74 11.4122 124 12.6239 124.02H120.026C121.118 124.011 122.198 123.806 123.203 123.419C124.208 123.031 125.12 122.467 125.885 121.759C126.65 121.052 127.254 120.214 127.662 119.295C128.071 118.375 128.276 117.391 128.266 116.4C128.253 115.262 127.96 114.141 127.407 113.12L73.7606 15.72C72.8159 13.944 71.1332 12.581 69.0823 11.9304C67.0313 11.2798 64.7798 11.3947 62.8221 12.25C61.1546 12.9838 59.808 14.2062 58.9997 15.72Z",
    fill: "#FFCC32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.2,
    d: "M70.8965 34.02C75.9636 34.02 80.0394 37.72 79.709 42.02L75.9636 90.02C75.5451 92.56 72.9454 94.32 70.1474 93.94C69.0592 93.7946 68.0515 93.3348 67.2737 92.6287C66.4959 91.9227 65.9894 91.0079 65.8293 90.02L62.084 42.02C61.7535 37.72 65.8293 34.02 70.8965 34.02ZM70.8965 98.02C74.5426 98.02 77.5058 100.71 77.5058 104.02C77.5058 107.33 74.5426 110.02 70.8965 110.02C67.2503 110.02 64.2871 107.33 64.2871 104.02C64.2871 100.71 67.2503 98.02 70.8965 98.02Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M70.8965 34.02C75.9636 34.02 80.0394 37.72 79.709 42.02L75.9636 90.02C75.5451 92.56 72.9454 94.32 70.1474 93.94C69.0592 93.7946 68.0515 93.3348 67.2737 92.6287C66.4959 91.9227 65.9894 91.0079 65.8293 90.02L62.084 42.02C61.7535 37.72 65.8293 34.02 70.8965 34.02Z",
    fill: "url(#paint0_linear_1145_413)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M70.8965 110.02C74.5467 110.02 77.5059 107.334 77.5059 104.02C77.5059 100.706 74.5467 98.02 70.8965 98.02C67.2462 98.02 64.2871 100.706 64.2871 104.02C64.2871 107.334 67.2462 110.02 70.8965 110.02Z",
    fill: "url(#paint1_linear_1145_413)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M58.9996 23.02C57.6778 24.52 35.4262 64.02 35.4262 64.02C35.4262 64.02 33.4434 67.02 36.1973 68.72C38.7309 70.32 41.0442 68.42 42.0356 66.92C43.027 65.42 63.1856 30.02 63.9567 28.32C64.6176 26.45 64.1549 24.41 62.7449 22.92C61.3129 21.72 59.8809 21.92 58.9996 23.02Z",
    fill: "#FFF170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M34.5451 78.63C36.5527 78.63 38.1802 77.1525 38.1802 75.33C38.1802 73.5075 36.5527 72.03 34.5451 72.03C32.5374 72.03 30.9099 73.5075 30.9099 75.33C30.9099 77.1525 32.5374 78.63 34.5451 78.63Z",
    fill: "#FFF170"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1145_413",
    x1: 70.8965,
    y1: 32.27,
    x2: 70.8965,
    y2: 110.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1145_413",
    x1: 70.8965,
    y1: 36.25,
    x2: 70.8965,
    y2: 114.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotoWarning);
export default __webpack_public_path__ + "static/media/noto_warning.3f3d1bf55df737d5e975c9d2ae9be3c8.svg";
export { ForwardRef as ReactComponent };